import { render, staticRenderFns } from "./CrearEncuesta.vue?vue&type=template&id=508a3b20&scoped=true&"
import script from "./CrearEncuesta.vue?vue&type=script&lang=js&"
export * from "./CrearEncuesta.vue?vue&type=script&lang=js&"
import style0 from "./CrearEncuesta.vue?vue&type=style&index=0&id=508a3b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a3b20",
  null
  
)

export default component.exports